import { createContext } from 'react';

import { MagicContextType } from './MagicContext.interface';

const defaultBitcoinMethods = {
  address: null,
  getBalance: async () => 0,
  send: async () => '',
  getAddress: async () => '',
};

export const MagicContext = createContext<MagicContextType>({
  magic: null,
  bitcoin: defaultBitcoinMethods,
});
